import { render, staticRenderFns } from "./SimulateCreditPage.vue?vue&type=template&id=2816d396&scoped=true"
import script from "./SimulateCreditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimulateCreditPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816d396",
  null
  
)

export default component.exports